/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMvSlider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setMvSlider = () => {
    if (window.document.body.classList.contains("home")) {
        let mvSlider = document.querySelector(".mv__slider");

        function mvSliderDataPosCounter() {
            let mvSliderDataPos = mvSlider.dataset.position;
            mvSliderDataPos === "0" ? mvSlider.dataset.position++ : mvSlider.dataset.position--;
        }
        window.setInterval(function () {
            mvSliderDataPosCounter();
        }, 6000);
    }
};

export {
    setMvSlider
}